import initialState from './initialState';
import { reducer as createPageReducer } from './createPage';
import { reducer as loadPagesReducer } from './loadPages';
import { reducer as loadCollectionsReducer } from './loadCollections';
import { reducer as toggleCreatePageReducer } from './toggleCreatePage';
import { reducer as toggleEmailSettingReducer } from './toggleEmailSetting';
import { reducer as toggleSidebarReducer } from './toggleSidebar';
import { reducer as togglePageModalReducer } from './togglePageModal';
import { reducer as loadProjectReducer } from './loadProject';
import { reducer as loadInstalledPluginsReducer } from './loadInstalledPlugins';
import { reducer as updatePageReducer } from './updatePage';
import { reducer as createSnippetTemplateReducer } from './createSnippetTemplate';
import { reducer as loadSnippetsReducer } from './loadSnippets';
import { reducer as toggleAssetUplodReducer } from './toggleAssetUplod';
import { reducer as loadProjectAssetsReducer } from './loadProjectAssets';
import { reducer as loadDefaultPageReducer } from './loadDefaultPage';
import { reducer as deletePageReducer } from './deletePage';
import { reducer as fetchPageDetailReducer } from './fetchPageDetail';
import { reducer as createPageSnapshotReducer } from './createPageSnapshot';
import { reducer as loadPageSnapshotsReducer } from './loadPageSnapshots';
import { reducer as toggleAssetSearchReducer } from './toggleAssetSearch';
import { reducer as uplodSearchedImageReducer } from './uplodSearchedImage';
import { reducer as deleteAssetReducer } from './deleteAsset';
import { reducer as deleteSnippetReducer } from './deleteSnippet';
import { reducer as uploadImageFromUrlReducer } from './uploadImageFromUrl';
import { reducer as updateSnippetReducer } from './updateSnippet';
import { reducer as createSnippetSnapshotReducer } from './createSnippetSnapshot';
import { reducer as loadSnippetSnapshotsReducer } from './loadSnippetSnapshots';
import { reducer as loadEventsReducer } from './loadEvents';
import { reducer as loadLayoutsReducer } from './loadLayouts';
import { reducer as loadExternalApisReducer } from './loadExternalApis';
import { reducer as updateLatestPublishVersionReducer } from './updateLatestPublishVersion';
import { reducer as hideBuilderLoaderReducer } from './hideBuilderLoader';
import { reducer as showBuilderLoaderReducer } from './showBuilderLoader';
import { reducer as getPermissionFlagsReducer } from './getPermissionFlags';
import { reducer as toggleDebugModeReducer } from './toggleDebugMode';
import { reducer as loadUserDetailsReducer } from './loadUserDetails';

const reducers = [
  createPageReducer,
  loadPagesReducer,
  loadCollectionsReducer,
  toggleCreatePageReducer,
  toggleEmailSettingReducer,
  toggleSidebarReducer,
  togglePageModalReducer,
  loadProjectReducer,
  loadInstalledPluginsReducer,
  updatePageReducer,
  createSnippetTemplateReducer,
  loadSnippetsReducer,
  toggleAssetUplodReducer,
  loadProjectAssetsReducer,
  loadDefaultPageReducer,
  deletePageReducer,
  fetchPageDetailReducer,
  createPageSnapshotReducer,
  loadPageSnapshotsReducer,
  toggleAssetSearchReducer,
  uplodSearchedImageReducer,
  deleteAssetReducer,
  deleteSnippetReducer,
  uploadImageFromUrlReducer,
  updateSnippetReducer,
  createSnippetSnapshotReducer,
  loadSnippetSnapshotsReducer,
  loadEventsReducer,
  loadLayoutsReducer,
  loadExternalApisReducer,
  updateLatestPublishVersionReducer,
  hideBuilderLoaderReducer,
  showBuilderLoaderReducer,
  getPermissionFlagsReducer,
  toggleDebugModeReducer,
  loadUserDetailsReducer,
];

export default function reducer(state = initialState, action) {
  let newState;
  switch (action.type) {
    default:
      newState = state;
      break;
  }
  return reducers.reduce((s, r) => r(s, action), newState);
}
